import * as Sentry from '@sentry/react'

export function registerGlobalErrorHandlers() {
  window.addEventListener('error', (event) => {
    Sentry.captureException(event, (scope) => {
      return scope
    })
  })

  window.addEventListener(
    'unhandledrejection',
    (event: PromiseRejectionEvent) => {
      Sentry.captureException(event, (scope) => {
        return scope
      })
    }
  )
}
